import { render, staticRenderFns } from "./SplitterStageRuleRelSafe.vue?vue&type=template&id=2a2f3ff8&scoped=true"
import script from "./SplitterStageRuleRelSafe.vue?vue&type=script&lang=js"
export * from "./SplitterStageRuleRelSafe.vue?vue&type=script&lang=js"
import style0 from "./SplitterStageRuleRelSafe.vue?vue&type=style&index=0&id=2a2f3ff8&prod&lang=less&scoped=true"
import style1 from "./SplitterStageRuleRelSafe.vue?vue&type=style&index=1&id=2a2f3ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f3ff8",
  null
  
)

export default component.exports